import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import JuristicList from '@app/views/LoanProgram/List';
import { memo } from 'react';

export default memo(
  withIfUser(JuristicList)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
